<template>
  <div class="container general-section documentation-section">

    <h1>
      <font-awesome-icon icon="file" />
      Dokumentation
    </h1>

    <div class="document-block">
      <h2>1. Affiliate agreement</h2>

      <p>Below you can download and read our default affiliate agreement to see the terms of collaboration with TecknaEl.</p>

      <p>
        <a href="https://cdn.tecknael.se/dokument/affiliate/default-affiliateavtal.pdf" class="btn btn-info">
          <font-awesome-icon icon="file-download" />
          Download default agreement (139 kb, PDF)
        </a>
      </p>

      <hr>
    </div>

    <div class="document-block">
      <h2>2. Widget integration</h2>

      <p>There are two ways of widget integration - simple one using iFrame, and more advanced - using TecknaEl API. The first one requires less technical knowledge from affiliate developers, but is less flexible, than second. Both of them are described in details below.</p>

      <h3>2a. Using iFrame (beginner)</h3>

      <p>
        Take the widget url and place it into the iFrame at your website link in example below. It is very important to include <small class="code">scrolling="no"</small> attribute into iFrame, otherwise internal scroll may appear in iFrame, and it may conflict with the rest of website.
      </p>

      <p>
        <textarea readonly class="code-textarea" v-html="iframe"></textarea>
      </p>

      <p>
        Styling-wise we recommend the following iFrame css-settings, so the basic set-up is looking good by the modern web-standards:
      </p>

      <ul>
        <li>
          <small class="code">width: 100%</small> so that iFrame is displayed at full width of parent block (by default it is not)
        </li>
        <li>
          <small class="code">border: 0</small> removes ugly default border around iFrame
        </li>
        <li>
          <small class="code">height: height: 533px;</small> for <b>Desktop</b> resolution
        </li>
        <li>
          <small class="code">height: height: 650px;</small> for <b>Mobile</b> resolution
        </li>
      </ul>

      <p>You can also customize the widget contents itself from TecknaEl Affiliate Dashboard. The possible customizations can be made in <router-link :to="{name: 'settings'}">Settings section</router-link>, they include background colour of the entire widget, button colour and custom CSS for button (for example to make different border-radius or font-size).</p>

      <div class="alert alert-info">
        If you feel you need more deep customization of widget, please, contact us at <a href="mailto:hej@tecknael.se">hej@tecknael.se</a>, and we will figure out a specific solution for your case.
      </div>

      <h3>2b. Using TecknaEl API (advanced)</h3>

      <div class="alert alert-warning">
        <h5>Notice</h5>
        <p class="mb-0">
          TecknaEl API is not released yet. We are currently working on its development and are planning to release beta version at autumn 2019. If you are interested in this advanced way of integration, please, let us know by email <a href="mailto:hej@tecknael.se">hej@tecknael.se</a>, and we will notify you as soon, as we have it ready.
        </p>
      </div>

      <hr>
    </div>

    <div class="document-block">
      <h2>3. Affiliate link integration</h2>

      <p>
        If you decide to not use widget, but have regular traffic, that you want to sell us, you can use the affiliate link integration. Affiliate link is a regular link to the main page of tecknael.se website, that has the uuid marker bound to your affiliate account.
      </p>

      <p>So when user visits our website via your link, we recognize the source of visit, and when user takes further actions (performs search of makes order), these actions are connected to your affiliate account and are displayed instantly in <router-link :to="{name: 'searches'}">Searches</router-link> or <router-link :to="{name: 'searches'}">Orders</router-link> sections.</p>

      <p>
        Make sure you specify the correct and full affiliate link at your website. It's easy to check - click on that link and make a search. If you see it instantly appearing in Searches section, then you made everything correct.
      </p>

      <p>Your affiliate link is <a :href="websiteLink(`?affiliate=${affiliate.uuid}`)" class="badge badge-info">{{ websiteLink(`?affiliate=${affiliate.uuid}`) }}</a>, you can also copy it in <router-link :to="{name: 'settings'}">Settings section</router-link>.</p>

      <hr>
    </div>

    <div class="document-block">
      <a name="earnings"></a>
      <h2>4. Earnings calculation</h2>

      <h3>4a. Payment for traffic</h3>

      <p>
        The earning is registered when user that visited TecknaEl website from affiliate performs search (electricity comparison). Important note: we count only unique searches, for example, if one user visited TecknaEl and performed 3 different searches, only one earning will be registered. You are able to see all the searches in <router-link :to="{name: 'searches'}">Searches section</router-link> and how many searches were performed for one earning in <router-link :to="{name: 'earnings'}">Earnings section</router-link>.
      </p>

      <h3>4b. Payment for completed orders</h3>

      <p>
        The earning is registered when user that visited TecknaEl website from affiliate completes the entire checkout process.
      </p>
    </div>

  </div>
</template>

<script>

  import {mapState} from 'vuex'

  export default {
    name: "Documentation",
    metaInfo() {
      return {
        title: 'Dokumentation'
      }
    },
    computed: {
      ...mapState({
        affiliate: state => state.auth.affiliate,
      }),
      iframe(){
        const src = this.websiteLink(`widget/${this.affiliate.uuid}`)

        return `<iframe :src="${src}" scrolling="no"></iframe>`
      }
    },
    mounted(){
      if (this.$router.currentRoute.hash) {
        this.$nextTick(() => {
          location.href = this.$router.currentRoute.hash
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard/Documentation/Index.vue